import { Outlet } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import "react-toastify/dist/ReactToastify.css";

import Theme from "Theme";
import Header from "./Header";

export default function Layout() {
  return (
    <Theme>
      <ToastContainer
        position="bottom-center"
        autoClose={3000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={true}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        icon={true}
        closeButton={false}
        style={{ fontFamily: "Kalameh !important" }}
      />
      <div
        style={{
          backgroundImage:
            "linear-gradient(217.21deg, rgba(50, 132, 255,0.0), rgba(32, 64, 233,0.9)), url(/assets/background.svg)",
          backgroundPosition: "center",
          backgroundSize: "cover",
          backgroundAttachment: "fixed",
          minHeight: "100vh",
          position: "relative",
        }}
      >
        <Header />

        <Outlet />
      </div>
    </Theme>
  );
}
